import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { BusinesscoItem, LogisticService, StockplaceItem } from '../../../services/logistic.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { RememberService } from '../../../core/services/remember.service';

@Component({
  selector: 'tt-batch-delivery-list',
  templateUrl: './batch-delivery-list.component.html',
  styleUrls: ['./batch-delivery-list.component.css']
})
export class BatchDeliveryListComponent implements OnInit {
    public selectedBgBatchDelivery: string = 'batchdelivery_in_progress';

    public setting?: Setting;

    public selectListCompanies: BusinesscoItem[] = [];

    public selectListStockPlaces: StockplaceItem[] = [];

    public selectListStockLocations: StockLocationItem[] = [];

    public itemsListBatchDeliveries: Item[] = [];

    public creatingNew = false;

    constructor(private stateService: StateService, private datatask: DataTaskService, private logistic: LogisticService, private rememberService: RememberService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(744))[0];
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private async loadStockPlaces() {
        if (!this.setting) return;

        return this.selectListStockPlaces = await this.logistic.getStockplaces({ businessco_no: this.setting.businessco_no });
    }

    private async loadStockLocations() {
        if (!this.setting) return;

        return this.selectListStockLocations = await this.datatask.Post(1029, {
            stockzoneclass_keyno: '1',
            stockplace_id: this.setting.stockplace_id,
            add_all: '1'
        });
    }

    private async loadBatchDeliveries() {
        if (!this.setting) return;

        return this.itemsListBatchDeliveries = await this.datatask.Post(278, {
            status: this.selectedBgBatchDelivery,
            businessco_no: this.setting.businessco_no,
            stockplace_id: this.setting.stockplace_id,
            stocklocation_keyno: this.setting.stocklocation_keyno
        });
    }

    private async retrieveLastStatus() {
        if (!this.setting) return;

        let variableName = 'batchdelivery_list.stocklocation_keyno.stockplace_id=' + this.setting.stockplace_id;

        const response = (await this.rememberService.getLastStatusEncoded(variableName, { urlencode_response: '1' }))[0];

        if (response?.variablevalue === '') {
            this.setting.stocklocation_keyno = '0';
        } else {
            this.setting.stocklocation_keyno = response?.variablevalue;
        }
    }

    public async createNewBatchDelivery() {
        if (!!this.setting) {
            try {
                this.creatingNew = true;

                const response = (await this.datatask.Post(280, {
                    businessco_no: this.setting.businessco_no,
                    stockplace_id: this.setting.stockplace_id,
                    stocklocation_keyno: this.setting.stocklocation_keyno
                }))[0];

                this.stateService.go(response?.webpagename, response?.parms);
            } finally {
                this.creatingNew = false;
            }
        }
    }

    public onTabChanged() {
        this.loadBatchDeliveries();
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'businessco_no':
                this.loadStockPlaces();
                break;
            case 'stockplace_id':
                Promise.all([
                    this.loadStockLocations(),
                    this.retrieveLastStatus()
                ]).then(() => {
                    this.loadBatchDeliveries();
                    Promise.resolve();
                });

                break;
            case 'stocklocation_keyno':
                this.loadBatchDeliveries();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadCompanies();

        return Promise.all([
            this.loadStockPlaces(),
            this.loadStockLocations()
        ]).then(() => {
            this.loadBatchDeliveries();
            Promise.resolve();
        });
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    businessco_no: string;
    stockplace_id: string;
    stocklocation_keyno: string;
}

interface StockLocationItem {
    stocklocation_keyno: string;
    stocklocation_name: string;
    orderby: number;
    item_id: string;
    item_name: string;
}
